import React from 'react';
import {Link} from 'react-router-dom';
import _BreadCrumb from './_BreadCrumb.scss';

class BreadCrumb extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data : this.props.data
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data != nextProps.data) {
      this.setState({
        data : nextProps.data
      });
    }
  }

  render() {
    return (
      <section className={`center ${this.props.classBreadCrum}`}>
        <div className="wrap-breadcrumb">
          {
            this.state.data.map((item, i) => {
              if (i == 0) {
                return (
                  <div className='breadcrumb' key={i}>
                    {
                      item.link ? (
                        <Link className='breadcrumb-link' to={item.link}>{item.name}</Link>
                      ) : (
                        <span>{item.name}</span>
                      )
                    }
                  </div>
                )
              } else {
                return (
                <div className='breadcrumb' key={i}>
                  {
                    item.link ? (
                      <div>
                        <span className='breadcrumb-slash'>/</span>
                        <Link className='breadcrumb-link' to={item.link}>{item.name}</Link>
                      </div>
                    ) : (
                      <div>
                        <span className='breadcrumb-slash'>/</span>
                        <span>{item.name}</span>
                      </div>
                    )
                  }
                </div>
              )
              }
            })
          }
        </div>
      </section>
    );
  }
}

BreadCrumb.defaultProps = {
  data: [],
  classBreadCrum: ''
};

export default BreadCrumb;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/BreadCrumb.jsx